import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
 * Display a localized price

 * Takes a currency argument
 * Usage:
 *   price | displayPrice:currency
 * Example:
 *   {{ 2 | displayPrice:'EUR' }}
 *   formats to: 2,00€
 *
 *   {{ 0 | displayPrice:'USD' }}
 *   formats to: free
*/
@Pipe({ name: 'displayPrice' })
export class DisplayPricePipe implements PipeTransform {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly translateService: TranslateService
  ) {}

  protected getFormattedPrice(value: number, currencyCode: string): string {
    return this.currencyPipe.transform(
      value,
      currencyCode,
      'symbol',
      null,
      this.translateService.currentLang
    );
  }

  public transform(
    value: number,
    currencyCode?: string,
    maxPrice?: number
  ): string {
    // If there are no currency or value (beside 0 for starting price)
    if (
      !currencyCode ||
      (!value && !maxPrice) ||
      (!value && value !== 0 && !maxPrice)
    ) {
      return this.translateService.instant('price.free');
    }

    const formattedPrice = this.getFormattedPrice(value, currencyCode);

    if (maxPrice && maxPrice > value) {
      const formattedMaxPrice = this.getFormattedPrice(maxPrice, currencyCode);
      return this.translateService.instant('price.range_price', {
        price: formattedPrice,
        lastPrice: formattedMaxPrice,
      });
    }

    return formattedPrice;
  }
}
